import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { FilterTabs } from '@/components'
import { DocumentFilterType } from '@/features/document/types'
import { DocumentType } from '@/schema'

interface TFLFilterTabsProps {
  activeTab: DocumentFilterType
  onTabChange: (tab: DocumentFilterType) => void
}

export const TFLFilterTabs: React.FC<TFLFilterTabsProps> = ({
  activeTab,
  onTabChange,
}) => {
  const { t } = useTranslation()

  const tabs: Record<DocumentFilterType, string> = useMemo(
    () => ({
      All: t('tflViewer.filters.all'),
      [DocumentType.TABLE]: t('tflViewer.filters.tables'),
      [DocumentType.FIGURE]: t('tflViewer.filters.figures'),
      [DocumentType.LIST]: t('tflViewer.filters.listings'),
    }),
    [t]
  )

  return (
    <FilterTabs
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={onTabChange}
      ariaLabel="TFL filters"
      tabClassName="px-2.5"
    />
  )
}
